import { render, staticRenderFns } from "./addChainInoutOrder.vue?vue&type=template&id=0c8a8526"
import script from "./addChainInoutOrder.vue?vue&type=script&lang=js"
export * from "./addChainInoutOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports